// Unidad de venta de un producto (sql/081). La mayoría se vende por
// unidad (entero); los productos por peso (pollo, carne, granos) se venden
// por libra o kilo y aceptan decimales: 12.5 lb.

export const UNIDADES = [
  { clave: 'unidad', label: 'Por unidad', corto: '' },
  { clave: 'lb', label: 'Por libra (lb)', corto: 'lb' },
  { clave: 'kg', label: 'Por kilo (kg)', corto: 'kg' },
];

export function unidadDe(producto) {
  return producto?.unidad || 'unidad';
}

export function esPorPeso(productoOUnidad) {
  const u = typeof productoOUnidad === 'string' ? productoOUnidad : unidadDe(productoOUnidad);
  return u === 'lb' || u === 'kg';
}

// Cuántos decimales se pueden escribir en la cantidad de este producto.
export function decimalesCantidad(productoOUnidad) {
  return esPorPeso(productoOUnidad) ? 2 : 0;
}

// Redondea a lo que guarda la base (3 decimales) para evitar 0.30000000000000004.
export function redondearCantidad(n) {
  return Math.round((Number(n) || 0) * 1000) / 1000;
}

// Textos del formulario de producto según cómo se vende.
export function textosCampoStock(productoOUnidad) {
  const u = typeof productoOUnidad === 'string' ? productoOUnidad : unidadDe(productoOUnidad);
  if (!esPorPeso(u)) return { label: 'Stock (cantidad)', ayuda: 'Cuántas unidades tienes. Solo números enteros.', porUnidad: '' };
  const nombre = u === 'lb' ? 'libras' : 'kilos';
  return {
    label: `Existencia (${u})`,
    ayuda: `Cuántas ${nombre} tienes. Puedes usar decimales, ej. 125.5`,
    porUnidad: ` por ${u === 'lb' ? 'libra' : 'kilo'}`,
  };
}

// "12.5 lb", "3" — para mostrar stock y cantidades.
export function formatoCantidad(n, productoOUnidad) {
  const u = typeof productoOUnidad === 'string' ? productoOUnidad : unidadDe(productoOUnidad);
  const texto = String(redondearCantidad(n));
  const corto = UNIDADES.find((x) => x.clave === u)?.corto;
  return corto ? `${texto} ${corto}` : texto;
}
